const copy = (text: string) => {
  let input = document.createElement('input');
  document.body.appendChild(input);
  input.value = text;
  input.select();
  document.execCommand('copy', false);
  input.remove(); 
}

export default copy;


// WEBPACK FOOTER //
// ./src/utils/copy.ts